module.exports = __webpack_public_path__ + "static/media/storefront.c2b39212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/categories/storefront.svg
// module id = 96
// module chunks = 0